import { Link as NovaBaseLink } from '@fme-nova/components'
import { alpha, Link as MuiBaseLink, LinkProps } from '@mui/material'

import { MUI_PALETTE, NOVA_PALETTE, styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiLink: MsdkStyledComponent<LinkProps> = styled(MuiBaseLink)`
  cursor: pointer;
  color: ${COLORS.primary.main};
  text-decoration-color: ${alpha(MUI_PALETTE.primary.main, 0.5)};
`

const NovaLink: MsdkStyledComponent<LinkProps> = styled(NovaBaseLink)`
  cursor: pointer;
  text-decoration-color: ${alpha(NOVA_PALETTE.primary.main, 0.5)};
`

export const Link = createComponentWrapperWithRef<LinkProps>(
  {
    mui: MuiLink,
    nova: NovaLink,
  },
  'Link',
)
